import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAppImage, LazyAppLink, LazyAppSource, LazySourceGroup, LazySvgIcon } from '#components'
const lazyGlobalComponents = [
  ["AppImage", LazyAppImage],
["AppLink", LazyAppLink],
["AppSource", LazyAppSource],
["SourceGroup", LazySourceGroup],
["SvgIcon", LazySvgIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
